/**
 * Die eine Wahrheit über „gültige E-Mail-Adresse" in dieser Anwendung. Beide
 * Meldewege — der öffentliche und der interne Dialog — fragen hier, damit ein
 * Melder nicht je nach Einstiegspunkt anderen Regeln unterliegt.
 *
 * Die Regel ist bewusst nachsichtig: mindestens ein Zeichen vor dem `@`,
 * mindestens eines danach, darin mindestens ein Punkt mit mindestens einem
 * Zeichen dahinter, keine Leerzeichen. Jede Verschärfung riskiert, eine reale
 * Adresse abzulehnen — und dann kommt der Mangel gar nicht erst herein.
 */
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Führende und nachlaufende Leerzeichen fallen weg, bevor geprüft wird: eine
 * aus einer anderen App kopierte Adresse soll nicht daran scheitern. Derselbe
 * getrimmte Wert ist auch der, der gespeichert und verschickt wird — sonst
 * prüfte man das eine und verschickte das andere.
 */
export const getrimmteEmailAdresse = (wert) => (wert ?? "").trim();

export const istGueltigeEmailAdresse = (wert) =>
  emailRegex.test(getrimmteEmailAdresse(wert));

/** In beiden Meldewegen wortgleich — der Melder soll denselben Satz lesen. */
export const EMAIL_HINWEIS = "Bitte eine gültige E-Mail-Adresse angeben.";
